import "./App.css";
import { CssBaseline, ThemeProvider, createTheme } from "@mui/material";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Layout from "./pages/layout";
import Dashboard from "./pages/dashboard";
import SignIn from "./pages/signIn/";
import SignUp from "./pages/signUp";
import RequireAuth from "./components/RequireAuth";
import Category from "./pages/category/Category";
import ManageCategory from "./pages/category/manageCategory/ManageCategory";
import Product from "./pages/product/Product";
import Coupon from "./pages/coupon/Coupon";
import ManageProduct from "./pages/product/manageProduct/ManageProduct";
import DetailsProduct from "./pages/product/detailsProduct/DetailsProduct";
import Settings from "./pages/settings/Settings";
import { useEffect } from "react";
import brandStore from "./stores/brandStore";
import RequireBrand from "./components/RequireBrand";
import ManageCoupon from "./pages/coupon/manageCoupon/ManageCoupon";
import Orders from "./pages/orders/Orders";
import OrderInDetails from "./pages/orders/orderInDetails/OrderInDetails";
import Demo from "./pages/demo/Demo";
import OrderRecipient from "./pages/orders/orderRecipient/OrderRecipient";
import Users from "./pages/users/Users";
import UserProfile from "./pages/users/userProfile/UserProfile";
import ReturnOrderRequest from "./pages/returnOrderRequest/ReturnOrderRequest";
import ContactUs from "./pages/contactUs/ContactUs";
import Heroes from "./pages/heroes/Heroes";
import ManageHero from "./pages/heroes/manageHero/ManageHero";

const defaultTheme = createTheme();

function App() {
  const BrandStore = brandStore();
  useEffect(() => {
    init();
  }, []);
  const init = async () => {
    await BrandStore.fetchBrand();
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      <BrowserRouter>
        <CssBaseline />
        <Routes>
          <Route path="/">
            <Route index element={<Navigate to="/sign-in" replace />} />
            <Route path="/demo" element={<Demo />} />
            <Route
              path="sign-in"
              element={
                <RequireBrand>
                  <SignIn />
                </RequireBrand>
              }
            />
            <Route
              path="sign-up"
              element={
                <RequireBrand>
                  <SignUp />
                </RequireBrand>
              }
            />
            <Route
              element={
                <RequireBrand>
                  <RequireAuth>
                    <Layout />
                  </RequireAuth>
                </RequireBrand>
              }
            >
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="category">
                <Route index element={<Category />} />
                <Route path="new" element={<ManageCategory />} />
                <Route path=":categoryID" element={<ManageCategory />} />
              </Route>
              <Route path="product">
                <Route index element={<Product />} />
                <Route path="new" element={<ManageProduct />} />
                <Route path=":productID" element={<ManageProduct />} />
                <Route path="details/:productID" element={<DetailsProduct />} />
              </Route>
              <Route path="orders">
                <Route index element={<Orders />} />
                <Route path=":paymentID/details" element={<OrderInDetails />} />
                <Route
                  path=":paymentID/invoice"
                  element={
                    <RequireBrand>
                      <RequireAuth>
                        <OrderRecipient />
                      </RequireAuth>
                    </RequireBrand>
                  }
                />
              </Route>
              <Route path="order-return-request">
                <Route index element={<ReturnOrderRequest />} />
                <Route path=":paymentID/details" element={<OrderInDetails />} />
                <Route
                  path=":paymentID/invoice"
                  element={
                    <RequireBrand>
                      <RequireAuth>
                        <OrderRecipient />
                      </RequireAuth>
                    </RequireBrand>
                  }
                />
              </Route>
              <Route path="coupon">
                <Route index element={<Coupon />} />
                <Route path="new" element={<ManageCoupon />} />
                <Route path=":couponID/edit" element={<ManageCoupon />} />
              </Route>
              <Route path="users">
                <Route index element={<Users />} />
                <Route path=":id/:username/profile" element={<UserProfile />} />
                {/* <Route path=":couponID/edit" element={<ManageCoupon />} /> */}
              </Route>
              <Route path="contact-us-via">
                <Route index element={<ContactUs />} />
                {/* <Route path=":couponID/edit" element={<ManageCoupon />} /> */}
              </Route>
              <Route path="settings">
                <Route index element={<Settings />} />
              </Route>
              <Route path="hero-management">
                <Route index element={<Heroes />} />
                <Route path="new" element={<ManageHero />} />
                <Route path=":heroID" element={<ManageHero />} />
              </Route>
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
